// extracted by mini-css-extract-plugin
module.exports = {"label":"FormReviewItem_label__2oHnC","value":"FormReviewItem_value__122lh"};